// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T15:47:03.725Z
// Property: Woodview at Randolph (ID: 6737460151193408)
// Collections: 26 amenities, 13 floorplans (live), 23 photos, 39 POIs, 4 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162250",
  "multihub_property_id": "6737460151193408",
  "property_external_id": "790000",
  "property_zillow_url": "https://www.zillow.com/apartments/randolph-ma/woodview-at-randolph/5XjrJ7/",
  "property_apartments_url": "https://www.apartments.com/woodview-at-randolph-randolph-ma/vf1g08f",
  "property_google_business_url": "https://www.google.com/maps/place/Woodview+at+Randolph/data=!4m2!3m1!1s0x0:0x41d728a92a42685e?sa=X&ved=2ahUKEwjbiKTXwbuSAxVRdPUHHZ8kIogQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "18468314501",
  "property_crm_software": "MRI CRM",
  "property_pm_software": "MRI",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "woodview-at-randolph",
  "property_name": "Woodview at Randolph",
  "property_website_url": "https://www.woodviewatrandolph.com/",
  "property_domain": "https://www.woodviewatrandolph.com/",
  "property_address": "33 Highland Glen Drive #106",
  "property_full_address": "33 Highland Glen Dr #106, Randolph, MA 02368",
  "property_address_1": "33 Highland Glen Dr",
  "property_address_2": "106",
  "property_address_city": "Randolph",
  "property_address_state": "MA",
  "property_address_zip_full": "02368",
  "property_address_zip": "02368",
  "property_address_country": "US",
  "property_address_county": "Norfolk County",
  "property_neighborhood_address": "Outer Quincy/Milton/Randolph",
  "property_address_latitude": "42.1622123",
  "property_address_longitude": "-71.05018609999999",
  "property_email": "woodview@dolben.com",
  "property_phone": "(781) 963-9227",
  "property_call_tracking_phone": "8447321839",
  "property_company_name": "DOLBEN",
  "property_company_url": "https://www.dolben.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Woodview At Randolph, where modern living meets comfort in the heart of Randolph, MA. Choose from stylish one- or two-bedroom floor plans and enjoy resort-style amenities like a refreshing pool, fitness center, and dog park. Ready to elevate your lifestyle? Browse our availability or schedule a tour today!",
  "property_long_description": "<p>Welcome home to your new apartment! Here at Woodview at Randolph, we pride ourselves in providing our residents with a community that takes comfort to the next level. With stunning features and amenities, a coveted location, and a variety of floor plans, living in Randolph, Massachusetts just got a whole lot better when you’re at Woodview at Randolph.</p><p>Convenience starts here at our apartment community. In addition to a swimming pool with a lifeguard, a BBQ picnic area, and disability access, our pet-friendly apartments have been updated to meet your every need. Depending on your selection of a studio, one-, or two-bedroom apartment, different features will be available to make your day-to-day life easier. Do you want wall-to-wall carpeting? Check! Do you prefer faux-granite countertops and air conditioning? We have them! Laundry facility? No worries there! Did we mention that you can make your payments online?</p><p>If you’re looking for an adventure, we’re conveniently located south of Boston. Take a few minutes to jump on the Fall River Expressway for a short drive to one of this country’s most historic cities. We’re also just minutes away from the MBTA Middleborough/Lakeville Line.</p><p>Coming home feels better at Woodview at Randolph. Our fabulous apartments and community have been filled with ample features, and no detail has been overlooked. Invest a moment of your time in return for what could be years of the best living experience you’ve ever known. We invite you to view our photo gallery to see a snapshot of what we offer.</p><p>Whether you’re looking for the perfect floor plan, a comfortable living experience, or a lot of amenities to help you relax, Woodview at Randolph has it all. Join us by becoming a part of our community so that you too can see how good life can be at our apartments in Randolph, MA.</p><p>Do you want to find a new and improved meaning to the term resident? Contact us today to schedule a tour and find out more!</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
  "property_featured_image_media": {
    "alt_text": "Dining area with a table set for four, adjacent to a kitchen.",
    "public_id": "019d07a0-aa4a-7717-b3a0-ac28d2b218a0",
    "storage_key": "property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
    "width": 1240,
    "height": 828
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "310",
  "property_year_built": "1966",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "5.333333333333334",
  "property_admin_fee": "200",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Admin Fee: $200. Application Fee: $50 per applicant",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "The following breeds are strictly prohibited: Rottweiler, Pit Bull (includes: American Pit Bull Terrier, American Staffordshire Terrier, Staffordshire Bull Terrier, American Bulldog, and Bull Terrier), Doberman, Siberian Husky, Akita, Chow, Mastiff, Great Dane, German Shepherd, Dalmatian, Alaskan Malamutes or, any mix of these breeds. For additional information or questions, please contact the leasing office.",
  "property_pet_policy_description": "We are a pet-friendly community! Dogs and cats are permitted - pet rent applies. There are no weight limits for dogs, but we do have breed restrictions.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://idolben.mriprospectconnect.com/790000",
  "property_resident_portal_url": "https://idolben.mriresidentconnect.com/",
  "property_apply_now_url": "https://idolben.mriprospectconnect.com/790000",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a12144-9515-7741-8342-5b42837dd3f8.webp",
  "property_primary_logo_media": {
    "alt_text": "Woodview at Randolph apartment homes logo",
    "public_id": "01a12144-9515-7741-8342-5b42837dd3f8",
    "storage_key": "property/6737460151193408/01a12144-9515-7741-8342-5b42837dd3f8.webp",
    "width": 180,
    "height": 59
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-94f9-724a-b2db-4406ddc4f3ff.webp",
  "property_secondary_logo_media": {
    "alt_text": "Dolben logo",
    "public_id": "019d07a0-94f9-724a-b2db-4406ddc4f3ff",
    "storage_key": "property/6737460151193408/019d07a0-94f9-724a-b2db-4406ddc4f3ff.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a155e8-9f2b-764a-847e-cd36aaaab680.webp",
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a12145-4697-7189-9ac8-d02ca86d08f5.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a12145-4697-7189-9ac8-d02ca86d08f5",
    "storage_key": "property/6737460151193408/01a12145-4697-7189-9ac8-d02ca86d08f5.webp",
    "width": 180,
    "height": 59
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a12145-3aab-74cf-807c-aaf737e7917c.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a12145-3aab-74cf-807c-aaf737e7917c",
    "storage_key": "property/6737460151193408/01a12145-3aab-74cf-807c-aaf737e7917c.webp",
    "width": 180,
    "height": 59
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162250/019d06ca-ee10-73da-bbff-8e8bec7c587b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162250/01a0e8dd-680d-75c9-beb0-c526714516d5.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#003820",
  "property_secondary_color": "#b8a755",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#003820",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "440 - 1097",
  "property_sqft_min": "440",
  "property_sqft_max": "1097",
  "property_price_range": "1745 - 2825",
  "property_price_min": "2070",
  "property_price_max": "2515",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/woodviewrandolph",
  "property_instagram_url": "https://www.instagram.com/woodviewatrandolph",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJz45_Z1WC5IkRXmhCKqko10E",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": "Apartments in Randolph, MA",
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "<p>Randolph is a fairly large town, just inland from Quincy and Weymouth on Interstate 93. The drive to Boston is only about 25 minutes and MBTA rail service is available as well, making it a highly convenient location for commuters or folks who just enjoy the occasional jaunt into the city.</p><p>The community itself is mainly residential, with clusters of locally-owned shops and restaurants on the north and south ends of Main Street. Goldstein Open Space and Bertha Soule Memorial Park near the center of town provide terrific grounds for getting outdoors and enjoying some fresh air, and the huge nature preserves near the coast are easily within day trip distance.</p>",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "<p>Randolph is a fairly large town, just inland from Quincy and Weymouth on Interstate 93. The drive to Boston is only about 25 minutes and MBTA rail service is available as well, making it a highly convenient location for commuters or folks who just enjoy the occasional jaunt into the city.</p><p>The community itself is mainly residential, with clusters of locally-owned shops and restaurants on the north and south ends of Main Street. Goldstein Open Space and Bertha Soule Memorial Park near the center of town provide terrific grounds for getting outdoors and enjoying some fresh air, and the huge nature preserves near the coast are easily within day trip distance.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At our pet-friendly community, we pride ourselves in knowing that you can go through your day and then come home to relax. Enjoy exciting features like wall-to-wall carpeting, European-style white cabinetry, central air conditioning, spacious closets, and more. Or, head outside to additional options for comfort and relaxation; our fabulous community acts as an extension of your apartment home. Enjoy using our fitness center to help you stay physically active, unlimited parking to fulfill all of you and your guests' parking needs, and extra storage facilities.</p>",
  "property_applynow_blurb": "At Woodview At Randolph, your ideal lifestyle awaits. Choose from stylish one or two-bedroom floor plans and indulge in exceptional amenities like a refreshing pool, modern fitness center, and cozy clubhouse. With a dog park for your furry friends and EV charging for your rides, this community is designed for you. Lease online today!",
  "property_contactus_blurb": "<p>Contact us if you have any questions, for more information, or to schedule your tour of our Randolph apartments.</p>",
  "property_faqs_blurb": "At Woodview At Randolph, we embrace a lifestyle tailored to your needs, featuring spacious one- and two-bedroom floor plans. Nestled in the heart of Randolph, MA, our community prioritizes comfort and convenience. Got questions? Dive into our FAQs page for insights about living here and enhancing your experience!",
  "property_floorplans_blurb": "<p>Take your comfort to the next level at Woodview at Randolph. Our apartments for rent in Randolph, MA feature spacious layouts designed with your lifestyle in mind. The brand-new building offers modern finishes, sleek cabinetry, and central air conditioning, while the rest of the community provides classic style with built-in A/C units, generous closets, and welcoming details. Whether you prefer modern luxury or timeless comfort, you’ll find your perfect fit at Woodview at Randolph.</p>",
  "property_gallery_blurb": "<p>Woodview at Randolph is comfortable apartment living at its finest, and you can see it for yourself by viewing our photo gallery. Take a moment to browse through our pet-friendly Randolph apartments.</p>",
  "property_interactivemap_blurb": "Welcome to Woodview at Randolph, where modern living meets comfort. Choose from stylish one and two-bedroom apartments nestled in a vibrant community featuring a sparkling pool, state-of-the-art fitness center, and a delightful dog park. Unleash convenience with our interactive community map to find your perfect home today!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "At Woodview At Randolph, we believe that great friends make great neighbors! Whether you seek a cozy one-bedroom haven or a spacious two-bedroom retreat, our diverse floor plans cater to every lifestyle. Share the joy of community living—refer a friend today and create lasting memories together right here in Randolph, MA!",
  "property_residentaccess_blurb": "<p>With convenient 24/7 access, the resident portal makes it easy for you to request maintenance service and pay your rent online. Log in to get started.</p>",
  "property_reviews_blurb": "<p>Check out our resident reviews!</p>",
  "property_created_at": "1752257383005",
  "property_scheduletour_blurb": "At Woodview At Randolph, experience a harmonious blend of comfort and style with our thoughtfully designed one and two-bedroom floor plans. Nestled in vibrant Randolph, MA, our apartments offer the perfect sanctuary. Curious about life here? Schedule a tour today and see what our residents love about their community!",
  "property_thankyou_blurb": "<p>A community leasing professional will contact you shortly!</p>",
  "property_virtualtours_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like a virtual tour. Take a look around - we know you'll love it here!</p>",
  "property_copyright": "2025 All Rights Reserved. Woodview At Randolph",
  "property_seo_title_home": "Woodview at Randolph | Randolph Apartments",
  "property_seo_description_home": "Woodview at Randolph offers spacious studio, 1, & 2 bedroom apartments for rent in Randolph, MA. Schedule your in-person tour today!",
  "property_seo_title_floorplans": "Floor Plans | Apartments for Rent in Randolph, MA",
  "property_seo_description_floorplans": "Experience exceptional amenities and pet-friendly apartment living at Woodview at Randolph. Explore our range of studio, 1, & 2 apartments in Randolph, MA!",
  "property_seo_title_amenities": "Amenities | Pet-Friendly Randolph Apartments For Rent",
  "property_seo_description_amenities": "Explore Woodview at Randolph in Randolph, MA, boasting a fitness center, swimming pool, BBQ picnic area, and more amenities! Contact us today!",
  "property_seo_title_gallery": "Gallery | Apartments For Rent in Randolph, MA",
  "property_seo_description_gallery": "Picture life at Woodview at Randolph at our pet-friendly Randolph apartments. Explore our gallery displaying studio, 1, and 2-bedroom layouts & amenities!",
  "property_seo_title_virtualtours": "Virtual Tour | Pet-Friendly Apartments in Randolph, MA",
  "property_seo_description_virtualtours": "Explore pet-friendly studio, one, and two-bedroom apartments at Woodview at Randolph in Randolph, MA. Check out our available virtual tours!",
  "property_seo_title_interactivemap": "Interactive Map | Woodview At Randolph Apartments",
  "property_seo_description_interactivemap": "Explore the vibrant lifestyle at Woodview at Randolph, nestled in the heart of Randolph, MA. Our beautifully designed one and two-bedroom apartments come with an array of exceptional amenities, from a refreshing pool and state-of-the-art fitness center to a cozy lounge and a pet washing station. Each home is perfectly situated with controlled access for peace of mind. Take the first step toward your new sanctuary—use our interactive community map to navigate available apartments, view pricing, and find your perfect fit today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Randolph, MA",
  "property_seo_description_neighborhood": "Woodview at Randolph is ideally situated near Pho So 1, Malai Thai, south of Boston, and other nearby attractions in Randolph, MA! Contact us today!",
  "property_seo_title_contact": "Contact Us | Apartments Randolph, MA",
  "property_seo_description_contact": "Contact us now to explore the modern amenities and array of studio, one-, and two-bedroom Randolph apartments waiting for you at Woodview at Randolph!",
  "property_seo_title_faqs": "FAQs | Apartments in Randolph, MA",
  "property_seo_description_faqs": "Unlock the secrets of comfortable living at Woodview At Randolph in MA! With chic one- and two-bedroom floor plans, our vibrant community offers a suite of amenities designed for your lifestyle. From serene poolside escapes and state-of-the-art fitness facilities to a stylish lounge and dog park, every inch is crafted for your enjoyment. Got questions? Our FAQ page is your gateway to understanding the perks of living here. Dive in to uncover everything Woodview At Randolph has to offer!",
  "property_seo_title_reviews": "Resident Reviews | Woodview at Randolph | Apts for Rent",
  "property_seo_description_reviews": "Gain valuable insights from resident reviews in Randolph, MA. Explore the convenience and luxury of apartment living at Woodview at Randolph!",
  "property_seo_title_applynow": "Apply Now | Studio, 1, & 2 Bedroom Randolph Apartments",
  "property_seo_description_applynow": "Excited to make Woodview at Randolph your new residence? Apply online now for our range of studio, one-, and two-bedroom floor plans in Randolph, MA!",
  "property_seo_title_residentaccess": "Resident Access | Modern Randolph, MA Apartments",
  "property_seo_description_residentaccess": "Enjoy convenience at Woodview at Randolph with our resident access portal. Request maintenance and pay rent online for a hassle-free experience.",
  "property_seo_title_referafriend": "Refer a Friend | Woodview at Randolph Apts For Rent",
  "property_seo_description_referafriend": "Invite a friend to Woodview at Randolph and unlock fantastic perks for both of you. Spread the word and reap the rewards!",
  "property_seo_title_scheduletour": "Schedule a Tour | Randolph, MA Apartments For Rent",
  "property_seo_description_scheduletour": "Experience modern comfort at Woodview at Randolph. Book a tour to explore our amenities and spacious studio, one, and two-bedroom apartments in Randolph, MA!",
  "property_seo_title_privacy": "Privacy Policy | Woodview At Randolph",
  "property_seo_description_privacy": "At Woodview At Randolph, your trust matters to us. Dive into our privacy policy to see how we safeguard your information while you enjoy all that our vibrant community in Randolph, MA has to offer. Your peace of mind is just a click away!",
  "property_seo_title_accessibility": "Website Accessibility | Woodview At Randolph",
  "property_seo_description_accessibility": "\"At Woodview at Randolph, we believe in creating a welcoming environment for everyone. Our Accessibility Statement highlights our commitment to digital inclusion and ensuring all residents and visitors can enjoy our vibrant community. Join us in making Randolph a place where everyone feels at home.\"",
  "property_seo_title_sitemap": "Sitemap | Woodview At Randolph",
  "property_seo_description_sitemap": "\"Navigate your future home at Woodview At Randolph with ease! Our sitemap guides you through the exceptional amenities, spacious floor plans, and vibrant community features that make Randolph, MA the perfect place to live. Plan your visit today!\"",
  "property_seo_title_thankyou": "Thank You | Woodview At Randolph",
  "property_seo_description_thankyou": "Thank you for your inquiry at Woodview At Randolph! Your journey toward an exceptional apartment experience in Randolph, MA, has just begun. A member of our dedicated team will reach out soon to assist you in finding your perfect home amidst serene surroundings and endless comforts. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Woodview at Randolph Pet-Friendly Apartments",
  "property_seo_description_pets": "Add extra levels of comfort to your lifestyle by checking out our spacious studio, 1, and 2-bedroom Randolph, MA apartments at Woodview at Randolph.",
  "property_updated_at": "1792509603058",
  "amenities": [
    {
      "id": "custom_b544190b-1387-490d-88d7-b0b4640ec8af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_55a717f3-cd6a-4d60-965b-e6a794c31e9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_30622c61-310a-4325-8406-6ce4453dcb1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_24376627-1e2a-49de-b443-40296a02080e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Community Courtyard",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f4ed7b6c-e486-4e73-ba57-5767a950b63f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Building Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d702cda3-8062-42a1-8eac-10d372ff0fd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient to Major Highways",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a58fc038-e096-4fe9-a446-c0b36a85e512",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient to MBTA",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_539b50a8-9892-4f04-b6b7-9ef7bc9a1a6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02f6a69b-48bb-4825-9162-af273f3ad330",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Extra Storage Facilities Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81aebe51-d9ec-46ba-bfe6-dd2cc6394316",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_acc2ec17-32d3-44c6-9db8-67619ad279d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "In-Ground Pool With Lifeguard",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_36097b60-c273-4c4a-a9e4-9c57b511b2c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities in Every Building",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91ea4647-a633-4972-b697-ad8020357a09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Online Work Orders",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c31d2af0-c865-4536-a8d8-f54571c024ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Professionally Managed by DOLBEN",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_703ad6be-2119-4efc-94ff-26f1b796b5a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Proud Affiliate of the NAA",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_740c2440-ee98-42f0-a483-0ef903fb1b74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Unlimited Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c0b9856-7964-4f3c-88c7-ff6eb1027348",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4e8a41b2-7f08-4b99-8edf-398c19e40e0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26fe628b-ba93-43d5-87e4-de7f017331be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_817a78a9-f754-45c2-af5a-3e8c04f2e227",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "European Style White Cabinetry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_92eb3e0f-63a4-4f02-a060-ad78c0316ab0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Faux Granite Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b0e739aa-c2b8-4e62-a1ef-5ead5d0cfcd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "In-Sink Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a170f5c9-ce04-49f2-b5e9-e8cf1feef798",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_230626dc-38a1-497a-8a29-54e04e158d41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Wall-To-Wall Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_63439d8c-4fbe-406d-aaf3-5039d1fd3cd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Whirlpool Appliances Including Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8dafccf6-195a-43a5-a10a-70de0254ee7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "external_id": "false",
      "title": "Furnished Apartments Available",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a6d3c7d3-c90f-4a5d-8f7e-7e77db185f01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-0fc5-717c-9e82-744741fedf99.webp",
      "image_media": {
        "alt_text": "Bright and airy living room and dining area with modern furniture.",
        "public_id": "019d07a0-0fc5-717c-9e82-744741fedf99",
        "storage_key": "property/6737460151193408/019d07a0-0fc5-717c-9e82-744741fedf99.webp",
        "width": 984,
        "height": 658
      },
      "title": "Apartment",
      "description": "Step into comfort with this beautifully appointed living and dining area. Featuring stylish furniture and ample space, it's perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Bright and airy living room and dining area with modern furniture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_380d86ce-c12f-4c70-9ed1-ce3b2d98449d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-047f-7710-8c44-332a1abb5ea9.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment.",
        "public_id": "019d07a0-047f-7710-8c44-332a1abb5ea9",
        "storage_key": "property/6737460151193408/019d07a0-047f-7710-8c44-332a1abb5ea9.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Stylish dining area with a fully equipped kitchen visible in the background, perfect for entertaining and everyday living.",
      "link": "false",
      "alt_text": "Dining area and kitchen in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d30bc92f-9fb8-41d4-a845-3f146ff4d008",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-1421-7361-b8ed-2aed8c678f49.webp",
      "image_media": {
        "alt_text": "Living room with a TV displaying the Woodview at Randolph logo, a white entertainment center, a blue armchair, and a glass coffee table.",
        "public_id": "019d07a0-1421-7361-b8ed-2aed8c678f49",
        "storage_key": "property/6737460151193408/019d07a0-1421-7361-b8ed-2aed8c678f49.webp",
        "width": 984,
        "height": 655
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a mounted TV, modern entertainment center, comfortable seating, and a large sliding glass door leading to the outdoors.",
      "link": "false",
      "alt_text": "Living room with a TV displaying the Woodview at Randolph logo, a white entertainment center, a blue armchair, and a glass coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7a2d023c-77b8-4455-aefe-5e442c3ea5a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-10b9-735e-ac31-2fda56c155f9.webp",
      "image_media": {
        "alt_text": "Spacious living room with a plush sofa, modern coffee table, and TV.",
        "public_id": "019d07a0-10b9-735e-ac31-2fda56c155f9",
        "storage_key": "property/6737460151193408/019d07a0-10b9-735e-ac31-2fda56c155f9.webp",
        "width": 2048,
        "height": 1369
      },
      "title": "Apartment",
      "description": "Enjoy the comfortable and stylish living area, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with a plush sofa, modern coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa9935f3-5cc2-428e-bef1-c654c28654f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-0707-779a-9c3e-6b0e0f42f44c.webp",
      "image_media": {
        "alt_text": "View of a dining area with a round table and chairs, leading into a living room with a sofa and chairs.",
        "public_id": "019d07a0-0707-779a-9c3e-6b0e0f42f44c",
        "storage_key": "property/6737460151193408/019d07a0-0707-779a-9c3e-6b0e0f42f44c.webp",
        "width": 984,
        "height": 655
      },
      "title": "Apartment",
      "description": "An inviting dining area with a marble-topped table and chairs, seamlessly connected to a comfortable living room, showcasing the spacious layout.",
      "link": "false",
      "alt_text": "View of a dining area with a round table and chairs, leading into a living room with a sofa and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_510d8425-4b66-4042-b64b-d5ab79b260f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-1404-72ad-988b-cb4ff26771e7.webp",
      "image_media": {
        "alt_text": "Bright living room with grey sofa, two blue armchairs, a glass coffee table, and abstract art on the wall.",
        "public_id": "019d07a0-1404-72ad-988b-cb4ff26771e7",
        "storage_key": "property/6737460151193408/019d07a0-1404-72ad-988b-cb4ff26771e7.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable grey sofa, elegant blue accent chairs, and modern abstract artwork, creating a chic and inviting atmosphere.",
      "link": "false",
      "alt_text": "Bright living room with grey sofa, two blue armchairs, a glass coffee table, and abstract art on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b4fb39c7-e8d6-4e91-9c7f-570e6da96ddf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-1e34-761c-af73-19cad0246d3d.webp",
      "image_media": {
        "alt_text": "Bedroom with dresser, mirror, open closet, and view of dining area.",
        "public_id": "019d07a0-1e34-761c-af73-19cad0246d3d",
        "storage_key": "property/6737460151193408/019d07a0-1e34-761c-af73-19cad0246d3d.webp",
        "width": 984,
        "height": 657
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a modern dresser with a round mirror, a large open closet with organized clothing, and a glimpse into the adjoining dining area.",
      "link": "false",
      "alt_text": "Bedroom with dresser, mirror, open closet, and view of dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b4370eb-a1cc-4ff0-a44b-c630ec7cfb39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-2207-7148-8ab3-d8b3e5c1a596.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, blue accent chair, dresser, and abstract art.",
        "public_id": "019d07a0-2207-7148-8ab3-d8b3e5c1a596",
        "storage_key": "property/6737460151193408/019d07a0-2207-7148-8ab3-d8b3e5c1a596.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and stylish bedroom featuring a comfortable king-size bed, a chic blue accent chair, and modern decor. Enjoy natural light from the large window.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, blue accent chair, dresser, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_678cd155-b6e6-4f73-8e05-33b8f41ce363",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-2369-768d-b116-2d9d8e8824f5.webp",
      "image_media": {
        "alt_text": "A bedroom with a large bed, nightstand, dresser, and window.",
        "public_id": "019d07a0-2369-768d-b116-2d9d8e8824f5",
        "storage_key": "property/6737460151193408/019d07a0-2369-768d-b116-2d9d8e8824f5.webp",
        "width": 2048,
        "height": 1371
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant nightstand, and a dresser with decorative accents, all bathed in natural light from the large window.",
      "link": "false",
      "alt_text": "A bedroom with a large bed, nightstand, dresser, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e2c15828-fb7f-4ab9-8af9-3e64b633fc5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-26a2-77a9-bb23-5ff228a96701.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, white bedding, bedside table, and closet.",
        "public_id": "019d07a0-26a2-77a9-bb23-5ff228a96701",
        "storage_key": "property/6737460151193408/019d07a0-26a2-77a9-bb23-5ff228a96701.webp",
        "width": 976,
        "height": 658
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed adorned with plush white bedding. Ample storage is provided by a large closet, and a cozy armchair adds a touch of elegance.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, white bedding, bedside table, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_26b566ec-ea83-48c2-82f5-167f77621c3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-309e-721f-aa98-87d3ca4e4110.webp",
      "image_media": {
        "alt_text": "Bathroom with white tiled shower and tub, vanity, and sink.",
        "public_id": "019d07a0-309e-721f-aa98-87d3ca4e4110",
        "storage_key": "property/6737460151193408/019d07a0-309e-721f-aa98-87d3ca4e4110.webp",
        "width": 984,
        "height": 656
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a white tiled shower and tub combination, a white vanity with a sink, and a mirror above.",
      "link": "false",
      "alt_text": "Bathroom with white tiled shower and tub, vanity, and sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_68ed9bf3-669e-4810-a6fe-6ccbe16d8938",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-32c6-704b-9142-f67e40c1bd05.webp",
      "image_media": {
        "alt_text": "Balcony access from apartment living room",
        "public_id": "019d07a0-32c6-704b-9142-f67e40c1bd05",
        "storage_key": "property/6737460151193408/019d07a0-32c6-704b-9142-f67e40c1bd05.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Apartment",
      "description": "Step out onto your private balcony from the spacious living room, featuring beautiful hardwood floors and ample natural light.",
      "link": "false",
      "alt_text": "Balcony access from apartment living room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba91b439-5fdb-4ec7-af80-3d5577492033",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d079f-dd25-713f-a0c1-fae71ea9667b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
        "public_id": "019d079f-dd25-713f-a0c1-fae71ea9667b",
        "storage_key": "property/6737460151193408/019d079f-dd25-713f-a0c1-fae71ea9667b.webp",
        "width": 984,
        "height": 657
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek white cabinetry, stainless steel appliances including a refrigerator, oven, and microwave, and a large central island perfect for meal prep or casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_209c01f9-4897-4101-844b-1ca8e58ab6a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d079f-e619-71e9-985a-3083e1bcdaa6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
        "public_id": "019d079f-e619-71e9-985a-3083e1bcdaa6",
        "storage_key": "property/6737460151193408/019d079f-e619-71e9-985a-3083e1bcdaa6.webp",
        "width": 984,
        "height": 657
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring sleek white cabinetry, stainless steel appliances, and a convenient island perfect for meal prep and casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_76d106ed-24e2-4bb2-abb5-c27133fa88ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d079f-e894-74fe-94c3-d50b28b033ee.webp",
      "image_media": {
        "alt_text": "Kitchen and living area with island and large windows.",
        "public_id": "019d079f-e894-74fe-94c3-d50b28b033ee",
        "storage_key": "property/6737460151193408/019d079f-e894-74fe-94c3-d50b28b033ee.webp",
        "width": 2048,
        "height": 1368
      },
      "title": "Apartment",
      "description": "Modern kitchen with an island, stainless steel appliances, and open-concept living space with ample natural light from large windows.",
      "link": "false",
      "alt_text": "Kitchen and living area with island and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c0ce0aa8-5d60-4f67-9461-52419647710b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d079f-edfc-76a0-947f-23718227f9e2.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer unit in a closet.",
        "public_id": "019d079f-edfc-76a0-947f-23718227f9e2",
        "storage_key": "property/6737460151193408/019d079f-edfc-76a0-947f-23718227f9e2.webp",
        "width": 2048,
        "height": 1368
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer located in a dedicated closet, making laundry day a breeze.",
      "link": "false",
      "alt_text": "Stackable washer and dryer unit in a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f3d94197-8eaa-464d-9dae-34c5d98f49e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d079f-f2b2-70af-8ebb-0113d14a5170.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, sink, toilet, and shower reflected in a large mirror.",
        "public_id": "019d079f-f2b2-70af-8ebb-0113d14a5170",
        "storage_key": "property/6737460151193408/019d079f-f2b2-70af-8ebb-0113d14a5170.webp",
        "width": 984,
        "height": 657
      },
      "title": "Apartment",
      "description": "This modern bathroom features a sleek white vanity with ample storage, a clean white sink, and a toilet. A large mirror above the vanity reflects the shower area.",
      "link": "false",
      "alt_text": "Modern bathroom with a white vanity, sink, toilet, and shower reflected in a large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4528477b-55da-4134-93a8-8bbec8985cde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d079f-f893-75e8-af8d-63ed45170cda.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with a white bathtub and shower.",
        "public_id": "019d079f-f893-75e8-af8d-63ed45170cda",
        "storage_key": "property/6737460151193408/019d079f-f893-75e8-af8d-63ed45170cda.webp",
        "width": 2048,
        "height": 1368
      },
      "title": "Apartment",
      "description": "Enjoy a relaxing soak in this modern apartment bathroom, featuring a clean white bathtub and shower combination.",
      "link": "false",
      "alt_text": "Modern apartment bathroom with a white bathtub and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6194a81-8dae-488a-87f0-a0d6fee6d73a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-02e1-7198-bb2a-9d8076598873.webp",
      "image_media": {
        "alt_text": "Balcony with white railings and wooden deck overlooking trees.",
        "public_id": "019d07a0-02e1-7198-bb2a-9d8076598873",
        "storage_key": "property/6737460151193408/019d07a0-02e1-7198-bb2a-9d8076598873.webp",
        "width": 984,
        "height": 657
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening breeze on your private balcony with scenic views.",
      "link": "false",
      "alt_text": "Balcony with white railings and wooden deck overlooking trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0efdccee-7559-4e6a-bb41-e72bbeb94594",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-33b5-7193-81fe-55442632c2ed.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "019d07a0-33b5-7193-81fe-55442632c2ed",
        "storage_key": "property/6737460151193408/019d07a0-33b5-7193-81fe-55442632c2ed.webp",
        "width": 984,
        "height": 656
      },
      "title": "Community",
      "description": "Relax by our sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas for your enjoyment.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and umbrellas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_218cfa1b-6a79-427c-a0a2-e4e17acc1a7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-3f59-7347-a9f1-6a62399dffb0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "019d07a0-3f59-7347-a9f1-6a62399dffb0",
        "storage_key": "property/6737460151193408/019d07a0-3f59-7347-a9f1-6a62399dffb0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas for relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_219b6bc8-05f7-48d9-a440-e0908dc5ece2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-4f0d-71ba-92da-d5a0a4133007.webp",
      "image_media": {
        "alt_text": "Woodview at Randolph apartment building exterior with sign.",
        "public_id": "019d07a0-4f0d-71ba-92da-d5a0a4133007",
        "storage_key": "property/6737460151193408/019d07a0-4f0d-71ba-92da-d5a0a4133007.webp",
        "width": 2048,
        "height": 1407
      },
      "title": "Community",
      "description": "Exterior view of the Woodview at Randolph apartment homes featuring a brick building, balconies, and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Woodview at Randolph apartment building exterior with sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8a43b00-4076-4b29-b509-483f8781e248",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-4f30-731b-97b4-6b1621ca953f.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with balconies and a green awning.",
        "public_id": "019d07a0-4f30-731b-97b4-6b1621ca953f",
        "storage_key": "property/6737460151193408/019d07a0-4f30-731b-97b4-6b1621ca953f.webp",
        "width": 180,
        "height": 116
      },
      "title": "Community",
      "description": "View the exterior of the apartment building, showcasing its brick facade, balconies, and well-maintained grounds.",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment building with balconies and a green awning.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_feb84087-84d3-4314-95f0-080a2e6721f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Hai Lua Plaza",
      "poi_type": "Shopping",
      "poi_address": "937 N Main St, Randolph, MA 02368, USA",
      "poi_short_description": "Hai Lua Plaza, is a nearby Shopping Center in Randolph MA, just 2.1 miles from Woodview At Randolph.",
      "poi_long_description": "Hai Lua Plaza Shopping Centers is a great place to shop for all your needs. The shopping center is conveniently located near Woodview At Randolph apartments and is only 2.1 mi away. With a variety of stores and businesses, Hai Lua Plaza Shopping Centers has something for everyone. Whether you're looking for a new outfit, a new home appliance, or just a place to grab a bite to eat, Hai Lua Plaza Shopping Centers is the place to be.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-4d9b-76de-823a-2fe8ba88a27c.webp",
      "poi_featured_image_media": {
        "alt_text": "Fresh fruit display at a market with oranges, dragon fruit, kiwis, and papayas.",
        "public_id": "01a10dc5-4d9b-76de-823a-2fe8ba88a27c",
        "storage_key": "property/6737460151193408/01a10dc5-4d9b-76de-823a-2fe8ba88a27c.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/hai-lua-plaza-randolph?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "hai-lua-plaza-randolph",
      "poi_latitude": "42.1870986458958",
      "poi_longitude": "-71.0557578876615",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_a63aef9b-b1e1-45d2-a2d8-14d205745ce9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Shaw's",
      "poi_type": "Shopping",
      "poi_address": "121 Memorial Pkwy, Randolph, MA 02368, USA",
      "poi_short_description": "Shaw's, is a nearby Grocery in Randolph MA, just 0.4 miles from Woodview At Randolph.",
      "poi_long_description": "Shaw's Grocery is conveniently located at 121 Memorial Pkwy in Randolph MA 02368, just minutes away from the Woodview At Randolph Apartments in 75035. If you're looking for the best apartments near Shaw's, Woodview At Randolph Apartments is the perfect choice. With Shaw's Grocery nearby, you'll never have to worry about running out of groceries. And if you're looking for apartments in Randolph MA, Woodview At Randolph Apartments is an excellent option.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-4beb-726b-bd52-beef86a73064.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a grocery store with flowers and balloons for sale.",
        "public_id": "01a10dc5-4beb-726b-bd52-beef86a73064",
        "storage_key": "property/6737460151193408/01a10dc5-4beb-726b-bd52-beef86a73064.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/shaws-randolph-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "shaws-randolph-2",
      "poi_latitude": "42.163823213309165",
      "poi_longitude": "-71.04548095767213",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_b0fc5d2a-b66f-44a6-a437-20a1a664313d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Hai Lua Farmer Guy Supermarket",
      "poi_type": "Shopping",
      "poi_address": "937 N Main St, Randolph, MA 02368, USA",
      "poi_short_description": "Hai Lua Farmer Guy Supermarket, is a nearby Grocery in Randolph MA, just 2.2 miles from Woodview At Randolph.",
      "poi_long_description": "If you're looking for a great grocery store near Woodview At Randolph Apartments, look no further than Hai Lua Farmer Guy Supermarket Grocery located at 937 North Main St Randolph MA 02368. It's the perfect place to pick up all the essentials you need for your home. Whether you're looking for fresh produce, organic ingredients, or pantry staples, Hai Lua Farmer Guy Supermarket Grocery has it all. Plus, with its convenient location, you can easily get to and from the store in no time. If you're looking for the best apartments near Hai Lua Farmer Guy Supermarket, look no further than Woodview At Randolph Apartments. Located in Randolph MA, Woodview At Randolph Apartments offers a variety of amenities and features that make it the perfect place to call home. With its convenient location and great amenities, Woodview At Randolph Apartments is the perfect place to call home.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/hai-lua-farmer-guy-supermarket-randolph?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "hai-lua-farmer-guy-supermarket-randolph",
      "poi_latitude": "42.1875646891041",
      "poi_longitude": "-71.0556395351887",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_7d7c85db-2953-4819-8118-30eee40ae003",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Saigon Market",
      "poi_type": "Shopping",
      "poi_address": "1112 N Main St, Randolph, MA 02368, USA",
      "poi_short_description": "Saigon Market, is a nearby Grocery in Randolph MA, just 2.6 miles from Woodview At Randolph.",
      "poi_long_description": "If you are looking for the best grocery store near Woodview At Randolph Apartments in 75035, Saigon Market Grocery located at 1112 N Main St Randolph MA 02368 is the place for you! This family-owned grocery store has been serving the Randolph MA area for over 30 years and offers a wide selection of fresh produce, meats, and other products. Whether you are looking for the best apartments near Saigon Market or simply want to find the best apartments in Randolph MA, Woodview At Randolph Apartments is the perfect place for you. With its convenient location and excellent amenities, Woodview At Randolph Apartments is the ideal place to call home. Stop by Saigon Market Grocery today and experience the best in grocery shopping near Woodview At Randolph Apartments.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/saigon-market-randolph?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "saigon-market-randolph",
      "poi_latitude": "42.1932784075812",
      "poi_longitude": "-71.060303",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_0c13ea7c-b339-4cc1-9129-8c7362a0dd09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Yamiyaki",
      "poi_type": "Restaurants",
      "poi_address": "50 N Main St, Randolph, MA 02368, USA",
      "poi_short_description": "Yamiyaki, is a popular Asian Fusion Restaurant in Randolph MA, just 0.4 miles from Woodview At Randolph.",
      "poi_long_description": "If you're looking for a delicious and unique dining experience, look no further than Yamiyaki Asian Fusion. This restaurant is located near Woodview At Randolph apartments and is just a short 0.4 mi walk away. At Yamiyaki, you'll enjoy a variety of Asian-inspired dishes that are sure to tantalize your taste buds. From sweet and savory to spicy and everything in between, there's something for everyone to enjoy at this one-of-a-kind restaurant. So come on over and see what all the fuss is about!",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/yamiyaki-randolph-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=50%20N%20Main%20St,%20Randolph,%20MA%2002368,%20USA&travelmode=driving",
      "poi_item_slug": "yamiyaki-randolph-2",
      "poi_latitude": "42.163549",
      "poi_longitude": "-71.042413",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_f3d4bad5-505e-44f3-bf9e-01a2de28eac3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Feng Shui Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "703 Granite St, Braintree, MA 02184, USA",
      "poi_short_description": "Feng Shui Restaurant & Bar, is a popular Sushi Bars Restaurant in Braintree MA, just 3.9 miles from Woodview At Randolph.",
      "poi_long_description": "Feng Shui Restaurant & Bar Sushi Bars is located near Woodview At Randolph apartments In Braintree, MA. The restaurant is 3.9 mi away from Woodview At Randolph apartments. Feng Shui Restaurant & Bar Sushi Bars has a wide variety of sushi rolls and sashimi, as well as hibachi entrees. The restaurant also has a full bar, with a wide selection of beers, wines, and cocktails.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/feng-shui-restaurant-and-bar-braintree?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=703%20Granite%20St,%20Braintree,%20MA%2002184,%20USA&travelmode=driving",
      "poi_item_slug": "feng-shui-restaurant-and-bar-braintree",
      "poi_latitude": "42.207315",
      "poi_longitude": "-71.022563",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_35310a35-d12e-4e23-93f4-74d4fe2e8fa0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "37 Forbes Rd, Braintree, MA 02184, USA",
      "poi_short_description": "Dave's Hot Chicken, is a popular Chicken Shop Restaurant in Braintree MA, just 7.7 miles from Woodview At Randolph.",
      "poi_long_description": "Dave's Hot Chicken Chicken Shop is a restaurant near Woodview At Randolph apartments in Braintree, MA. It is 7.7 mi away from Woodview At Randolph apartments. Dave's Hot Chicken Chicken Shop is a family-owned restaurant that has been serving the community for over 30 years. The restaurant is known for its hot chicken, which is made with a secret recipe that has been passed down for generations. The chicken is served with a variety of sides, including mashed potatoes, green beans, and coleslaw. The restaurant also offers a variety of desserts, including pies, cakes, and cookies.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/daves-hot-chicken-braintree-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=37%20Forbes%20Rd,%20Braintree,%20MA%2002184,%20USA&travelmode=driving",
      "poi_item_slug": "daves-hot-chicken-braintree-2",
      "poi_latitude": "42.22015",
      "poi_longitude": "-71.03021",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_f748d5a0-53fb-4241-a155-5a2a0274a46c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Dora Taqueria",
      "poi_type": "Restaurants",
      "poi_address": "17 Union St, Weymouth, MA 02190, USA",
      "poi_short_description": "Dora Taqueria, is a popular Mexican Restaurant in Weymouth MA, just 6.0 miles from Woodview At Randolph.",
      "poi_long_description": "If you're in the mood for some delicious Mexican food, look no further than Dora Taqueria! This restaurant is located near Woodview At Randolph apartments in Weymouth, MA and is only 6.0 mi away. They offer a wide variety of Mexican dishes that are sure to satisfy your cravings. From tacos and burritos to enchiladas and quesadillas, they have something for everyone. And don't forget to try their famous margaritas! Whether you're in the mood for a casual meal or a night out with friends, Dora Taqueria is the perfect spot.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/dora-taqueria-weymouth?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=17%20Union%20St,%20Weymouth,%20MA%2002190,%20USA&travelmode=driving",
      "poi_item_slug": "dora-taqueria-weymouth",
      "poi_latitude": "42.17380447374538",
      "poi_longitude": "-70.9506144916591",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_4f02e438-f94f-442b-bbef-fdef18f54827",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Oriental Gourmet",
      "poi_type": "Restaurants",
      "poi_address": "15 Vernon St, Quincy, MA 02169, USA",
      "poi_short_description": "Oriental Gourmet, is a popular Chinese Restaurant in Quincy MA, just 9.4 miles from Woodview At Randolph.",
      "poi_long_description": "If you're in the mood for some delicious Chinese food, look no further than Oriental Gourmet. Located near Woodview At Randolph apartments, this restaurant is the perfect place to satisfy your cravings. With a wide variety of menu items to choose from, there's something for everyone at Oriental Gourmet. And if you're looking for a place to relax and unwind after a long day, the restaurant's cozy atmosphere is just what you need. So come on over and enjoy a delicious meal at Oriental Gourmet.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/oriental-gourmet-quincy?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=15%20Vernon%20St,%20Quincy,%20MA%2002169,%20USA&travelmode=driving",
      "poi_item_slug": "oriental-gourmet-quincy",
      "poi_latitude": "42.236612806164686",
      "poi_longitude": "-71.014762",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_81b35d45-d4ca-4c88-97b3-e9e7b67415f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Life Alive Organic Cafe - Dedham",
      "poi_type": "Restaurants",
      "poi_address": "220 Legacy Pl, Dedham, MA 02026, USA",
      "poi_short_description": "Life Alive Organic Cafe - Dedham, is a popular Juice Bars & Smoothies Restaurant in Dedham MA, just 11.2 miles from Woodview At Randolph.",
      "poi_long_description": "Life Alive Organic Cafe is a restaurant that serves juice, smoothies, and healthy food. They have locations in Dedham and Cambridge, and their mission is to create a healthy and delicious dining experience for their customers. The Dedham location is near Woodview At Randolph apartments and is 11.2 mi away from Woodview At Randolph apartments. They offer a variety of juices, smoothies, and bowls that are made with fresh, organic ingredients. Their menu changes seasonally to offer new and exciting flavors, and they also have a kids menu. Life Alive is a great place to go for a healthy meal or snack, and their juices and smoothies are perfect for a post-workout refuel.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/life-alive-organic-cafe-dedham-dedham?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=220%20Legacy%20Pl,%20Dedham,%20MA%2002026,%20USA&travelmode=driving",
      "poi_item_slug": "life-alive-organic-cafe-dedham-dedham",
      "poi_latitude": "42.231226",
      "poi_longitude": "-71.176492",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_8254807d-1258-46fb-aa3e-c931a99a416d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "The Capital Grille",
      "poi_type": "Restaurants",
      "poi_address": "410 Legacy Pl, Dedham, MA 02026, USA",
      "poi_short_description": "The Capital Grille, is a popular Steakhouses Restaurant in Dedham MA, just 10.8 miles from Woodview At Randolph.",
      "poi_long_description": "The Capital Grille Steakhouses is a restaurant located near Woodview At Randolph apartments in Dedham, MA and is 10.8 mi away from Woodview At Randolph apartments. The Capital Grille Steakhouses is a fine dining establishment that serves American cuisine, including steaks, seafood, and chops. The restaurant has an extensive wine list and a private dining room that can accommodate up to 50 people. The Capital Grille Steakhouses is open for lunch and dinner, and reservations are recommended.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/the-capital-grille-dedham?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=410%20Legacy%20Pl,%20Dedham,%20MA%2002026,%20USA&travelmode=driving",
      "poi_item_slug": "the-capital-grille-dedham",
      "poi_latitude": "42.23165",
      "poi_longitude": "-71.17932",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "5 hours 0 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_1afb42ac-19a0-4a43-93a8-7be5f48538a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Love & Light",
      "poi_type": "Restaurants",
      "poi_address": "4255 Washington St, Boston, MA 02131, USA",
      "poi_short_description": "Love & Light, is a popular Salad Restaurant in Boston MA, just 11.0 miles from Woodview At Randolph.",
      "poi_long_description": "Love & Light Salad is a restaurant located near Woodview At Randolph apartments in Boston, MA. The restaurant is 11.0 mi away from Woodview At Randolph apartments and specializes in salads. The menu features a variety of salads, including a Greek salad, a Caesar salad, and a spinach salad. The restaurant also offers soups, sandwiches, and wraps.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/love-and-light-boston?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=4255%20Washington%20St,%20Boston,%20MA%2002131,%20USA&travelmode=driving",
      "poi_item_slug": "love-and-light-boston",
      "poi_latitude": "42.28561",
      "poi_longitude": "-71.12929",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_9f70c907-8f0a-4c4c-a4ee-248d154e47a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Kura Revolving Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "39A District Ave, Dorchester, MA 02125, USA",
      "poi_short_description": "Kura Revolving Sushi Bar, is a popular Conveyor Belt Sushi Restaurant in Dorchester MA, just 16.7 miles from Woodview At Randolph.",
      "poi_long_description": "Kura Revolving Sushi Bar Conveyor Belt Sushi restaurant is a great place to eat at if you enjoy sushi. This restaurant is located near Woodview At Randolph apartments and is only 16.7 mi away, making it a great place to eat at if you live in the Dorchester, MA area. The sushi at this restaurant is some of the best that you will ever have and you will definitely enjoy your experience eating here.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/kura-revolving-sushi-bar-dorchester-4?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=39A%20District%20Ave,%20Dorchester,%20MA%2002125,%20USA&travelmode=driving",
      "poi_item_slug": "kura-revolving-sushi-bar-dorchester-4",
      "poi_latitude": "42.32591067785442",
      "poi_longitude": "-71.06245160322935",
      "poi_miles_from_property": "16.7 mi",
      "poi_walking_minutes": "5 hours 32 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_cb585785-139a-4fd7-b8a5-8a14c8e322cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "The Dirty Italian",
      "poi_type": "Restaurants",
      "poi_address": "144 Old Colony Ave, Boston, MA 02127, USA",
      "poi_short_description": "The Dirty Italian, is a popular Sandwiches Restaurant in South Boston MA, just 16.5 miles from Woodview At Randolph.",
      "poi_long_description": "The Dirty Italian Sandwiches restaurant is located near Woodview At Randolph apartments In South Boston, MA and Is 16.5 mi away from Woodview At Randolph apartments. The restaurant serves up delicious Italian sandwiches that are sure to satisfy your hunger. The restaurant also has a wide variety of other menu items that you can choose from, including salads, pasta dishes, and pizzas. The Dirty Italian Sandwiches restaurant is a great place to eat when you're looking for a tasty meal that won't break the bank.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/the-dirty-italian-south-boston?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=144%20Old%20Colony%20Ave,%20Boston,%20MA%2002127,%20USA&travelmode=driving",
      "poi_item_slug": "the-dirty-italian-south-boston",
      "poi_latitude": "42.33489",
      "poi_longitude": "-71.0549",
      "poi_miles_from_property": "16.5 mi",
      "poi_walking_minutes": "5 hours 38 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_40c9fba1-8f3e-4fb1-a3fc-03581a6207f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Pho 98°C",
      "poi_type": "Entertainment",
      "poi_address": "94 N Main St, Randolph, MA 02368, USA",
      "poi_short_description": "Pho 98°C, is a popular nightlife spot in Randolph MA, just 0.6 miles from Woodview At Randolph.",
      "poi_long_description": "If you're looking for a delicious Vietnamese meal near Woodview At Randolph apartments, be sure to check out Pho 98°C. This restaurant is located just 0.6 mi away and offers a variety of mouth-watering dishes, including pho, bánh mì, and spring rolls. The friendly staff will make you feel right at home, and the prices are very reasonable. Whether you're in the mood for a light lunch or a hearty dinner, Pho 98°C is sure to please.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-4bef-7681-9c81-ac31317767f5.webp",
      "poi_featured_image_media": {
        "alt_text": "Delicious meal with fried meat and vegetables",
        "public_id": "01a10dc5-4bef-7681-9c81-ac31317767f5",
        "storage_key": "property/6737460151193408/01a10dc5-4bef-7681-9c81-ac31317767f5.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/pho-98-c-randolph-4?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=94%20N%20Main%20St,%20Randolph,%20MA%2002368,%20USA&travelmode=driving",
      "poi_item_slug": "pho-98-c-randolph-4",
      "poi_latitude": "42.16436912598343",
      "poi_longitude": "-71.04306188747816",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Night",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_2403d34e-9ac4-4237-a508-69af47908009",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Mojitos Latin Lounge & Nightclub",
      "poi_type": "Entertainment",
      "poi_address": "44 Mazzeo Dr, Randolph, MA 02368, USA",
      "poi_short_description": "Mojitos Latin Lounge & Nightclub, is a popular nightlife spot in Randolph MA, just 1.1 miles from Woodview At Randolph.",
      "poi_long_description": "Looking for a Latin-themed night out on the town? Mojitos Latin Lounge & Nightclub is the perfect spot! Located just 1.1 miles from Woodview At Randolph apartments, this trendy bar is a hot spot for locals and visitors alike. Whether you're looking to relax with a mojito in hand or dance the night away, Mojitos is sure to please. With a fun and festive atmosphere, this is the perfect place to let loose and have a good time!",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/mojitos-latin-lounge-and-nightclub-randolph?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=44%20Mazzeo%20Dr,%20Randolph,%20MA%2002368,%20USA&travelmode=driving",
      "poi_item_slug": "mojitos-latin-lounge-and-nightclub-randolph",
      "poi_latitude": "42.1633567810059",
      "poi_longitude": "-71.05810546875",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Night",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_a16d027e-1e07-4558-906e-4dc4ab0fc2ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "It's Game Time Sports Bar & Taqueria",
      "poi_type": "Entertainment",
      "poi_address": "47 Mazzeo Dr, Randolph, MA 02368, USA",
      "poi_short_description": "It's Game Time Sports Bar & Taqueria, is a popular nightlife spot in Randolph MA, just 1.1 miles from Woodview At Randolph.",
      "poi_long_description": "It's Game Time Sports Bar & Taqueria Mexican is the perfect place to catch all the big games and enjoy some delicious Mexican food. The bar is located near Woodview At Randolph apartments and is just 1.1 mi away, making it the perfect place to stop for a quick bite or a few drinks before heading home. The bar has a great selection of beers and cocktails, and the kitchen serves up some of the best tacos and burritos in town. Whether you're looking for a place to watch the game or just want some good food, It's Game Time Sports Bar & Taqueria Mexican is the place to be.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-4daf-725b-92b7-dda998191ea8.webp",
      "poi_featured_image_media": {
        "alt_text": "A close-up shot of a basket of fried chicken wings with dipping sauce.",
        "public_id": "01a10dc5-4daf-725b-92b7-dda998191ea8",
        "storage_key": "property/6737460151193408/01a10dc5-4daf-725b-92b7-dda998191ea8.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/its-game-time-sports-bar-and-taqueria-randolph?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=47%20Mazzeo%20Dr,%20Randolph,%20MA%2002368,%20USA&travelmode=driving",
      "poi_item_slug": "its-game-time-sports-bar-and-taqueria-randolph",
      "poi_latitude": "42.164465871718896",
      "poi_longitude": "-71.06009343146064",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Night",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_ee7bcbae-c124-424c-846c-a49dc34cbabe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "West End Grill",
      "poi_type": "Entertainment",
      "poi_address": "53 Mazzeo Dr, Randolph, MA 02368, USA",
      "poi_short_description": "West End Grill, is a popular nightlife spot in Randolph MA, just 1.1 miles from Woodview At Randolph.",
      "poi_long_description": "Welcome to West End Grill New American, a modern and stylish American grill located near Woodview At Randolph apartments in Randolph, MA. Our menu features classic American favorites with a twist, as well as a variety of unique and innovative dishes. Whether you're in the mood for a juicy burger, a fresh salad, or a hearty steak, we've got you covered. We also have an extensive wine list and a full bar, so you can enjoy a delicious meal with your favorite beverage. Come experience our welcoming atmosphere and fabulous food today!",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-4bf2-74bf-8d7d-41a66800f6d5.webp",
      "poi_featured_image_media": {
        "alt_text": "A close-up shot of baked macaroni and cheese in a white oval dish on a black table.",
        "public_id": "01a10dc5-4bf2-74bf-8d7d-41a66800f6d5",
        "storage_key": "property/6737460151193408/01a10dc5-4bf2-74bf-8d7d-41a66800f6d5.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/west-end-grill-randolph?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=53%20Mazzeo%20Dr,%20Randolph,%20MA%2002368,%20USA&travelmode=driving",
      "poi_item_slug": "west-end-grill-randolph",
      "poi_latitude": "42.1640008584226",
      "poi_longitude": "-71.0603059083223",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Night",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_912eaf15-fe6f-48c7-a214-9d1055b0ea69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "TGI Fridays",
      "poi_type": "Entertainment",
      "poi_address": "2 Hawes Wy, Stoughton, MA 02072, USA",
      "poi_short_description": "TGI Fridays, is a popular nightlife spot in Stoughton MA, just 2.2 miles from Woodview At Randolph.",
      "poi_long_description": "If you're looking for a delicious American meal near Woodview At Randolph apartments, be sure to check out TGI Fridays. With classic dishes like hamburgers, chicken wings, and french fries, there's something for everyone to enjoy. And with a convenient location just 2.2 mi away from Woodview At Randolph apartments, you won't have to go far to get your TGI Fridays fix.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-4be9-7434-b1c9-942b7a1af725.webp",
      "poi_featured_image_media": {
        "alt_text": "Menu photo showcasing whiskey-glaze blaze frijitas, dynamite shrimp, and tandoori chicken.",
        "public_id": "01a10dc5-4be9-7434-b1c9-942b7a1af725",
        "storage_key": "property/6737460151193408/01a10dc5-4be9-7434-b1c9-942b7a1af725.webp",
        "width": 903,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/tgi-fridays-stoughton-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=2%20Hawes%20Wy,%20Stoughton,%20MA%2002072,%20USA&travelmode=driving",
      "poi_item_slug": "tgi-fridays-stoughton-2",
      "poi_latitude": "42.1534300967561",
      "poi_longitude": "-71.0728311264066",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Night",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_9a6b7530-1f18-460c-8ce7-3ce9af7dbeb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Randolph Dog Park",
      "poi_type": "Entertainment",
      "poi_address": "167 West St, Randolph, MA 02368, USA",
      "poi_short_description": "Randolph Dog Park, is a nearby Park in Randolph MA, just 0.9 miles from Woodview At Randolph.",
      "poi_long_description": "Randolph Dog Park is a popular destination for dog owners living in the Woodview At Randolph apartments. The park is located just 1375 miles away from the apartments, making it a convenient spot for a quick walk or play session with your furry friend. The park features a large, fenced-in area for dogs to run and play off-leash, as well as a smaller section for smaller breeds. There is also a water fountain for dogs to drink from, and plenty of benches for owners to relax and watch their dogs play.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-4d48-722a-a2e3-32cf25786404.webp",
      "poi_featured_image_media": {
        "alt_text": "Ruff Road street sign in a wooded area",
        "public_id": "01a10dc5-4d48-722a-a2e3-32cf25786404",
        "storage_key": "property/6737460151193408/01a10dc5-4d48-722a-a2e3-32cf25786404.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/randolph-dog-park-randolph?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "randolph-dog-park-randolph",
      "poi_latitude": "42.16778392655488",
      "poi_longitude": "-71.05382222806729",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJz45_Z1WC5IkRXmhCKqko10E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_1dbba5aa-1a9b-497e-9889-f40438b92e20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Powers Farm Community Park",
      "poi_type": "Entertainment",
      "poi_address": "592 N Main St, Randolph, MA 02368, USA",
      "poi_short_description": "Powers Farm Community Park, is a nearby Park in Randolph MA, just 1.4 miles from Woodview At Randolph.",
      "poi_long_description": "Powers Farm Community Park is a great place to take a break from the hustle and bustle of city life. The park is located near Woodview At Randolph apartments, and is just a short 2211 miles away. The park features a variety of amenities, including a playground, picnic tables, and a walking trail. Powers Farm Community Park is the perfect place to enjoy a peaceful afternoon with family and friends.",
      "poi_featured_image": "https://s3-media1.fl.yelpcdn.com/bphoto/m1oLZKM9yYqnbiGtEMpxYQ/o.jpg",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/powers-farm-community-park-randolph?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "powers-farm-community-park-randolph",
      "poi_latitude": "42.1769",
      "poi_longitude": "-71.04985",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJz45_Z1WC5IkRXmhCKqko10E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_8693af3c-01c1-4223-aff2-57718a2c0b66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Hollingsworth Park",
      "poi_type": "Entertainment",
      "poi_address": "17 Lake St, Braintree, MA 02184, USA",
      "poi_short_description": "Hollingsworth Park, is a nearby Park in Braintree MA, just 3.5 miles from Woodview At Randolph.",
      "poi_long_description": "Hollingsworth Park is a beautiful 56-acre park located near Woodview At Randolph apartments in Braintree, MA. The park features a playground, picnic area, walking trails, and a pond. The pond is stocked with fish and is a popular spot for fishing and ice skating in the winter.",
      "poi_featured_image": "https://s3-media4.fl.yelpcdn.com/bphoto/2PlWC_-P_S572FSvKozwsw/o.jpg",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/hollingsworth-park-braintree?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "hollingsworth-park-braintree",
      "poi_latitude": "42.1974493",
      "poi_longitude": "-71.0233262",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJz45_Z1WC5IkRXmhCKqko10E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_9d77c6a5-b20a-4324-98fc-dc9fc2fd5a3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Holbrook Town Forest",
      "poi_type": "Entertainment",
      "poi_address": "320R Weymouth St, Holbrook, MA 02343, USA",
      "poi_short_description": "Holbrook Town Forest, is a nearby Park in Holbrook MA, just 4.8 miles from Woodview At Randolph.",
      "poi_long_description": "The Holbrook Town Forest Hiking is a great place to go for a hike near the Woodview At Randolph apartments. The forest is 7663 miles away from the apartments and is a great place to explore nature. The trails are well marked and there are plenty of places to stop and rest along the way.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-6a82-731e-909a-f550bcb5b038.webp",
      "poi_featured_image_media": {
        "alt_text": "Autumn forest scene with trees showing fall colors.",
        "public_id": "01a10dc5-6a82-731e-909a-f550bcb5b038",
        "storage_key": "property/6737460151193408/01a10dc5-6a82-731e-909a-f550bcb5b038.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/holbrook-town-forest-holbrook?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "holbrook-town-forest-holbrook",
      "poi_latitude": "42.166075",
      "poi_longitude": "-70.988869",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJz45_Z1WC5IkRXmhCKqko10E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_980fac79-acbf-4ecf-a4d3-49d6a62869b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Faxon Park",
      "poi_type": "Entertainment",
      "poi_address": "85 Park St, Stoughton, MA 02072, USA",
      "poi_short_description": "Faxon Park, is a nearby Park in Stoughton MA, just 4.8 miles from Woodview At Randolph.",
      "poi_long_description": "Founded in 1885, Faxon Park is one of the oldest parks in Stoughton, Massachusetts. The park is situated on 77 acres of land and features a playground, basketball courts, a baseball field, and a pond. The pond is a popular spot for fishing and is stocked with trout each spring. Faxon Park is also home to a variety of wildlife, including ducks, geese, and turtles.",
      "poi_featured_image": "https://s3-media1.fl.yelpcdn.com/bphoto/klrIyZBsn9C1giClJutCVw/o.jpg",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/faxon-park-stoughton?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "faxon-park-stoughton",
      "poi_latitude": "42.122446813139874",
      "poi_longitude": "-71.0994885842955",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJz45_Z1WC5IkRXmhCKqko10E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_d41c2383-e3f2-443d-968d-9fe445991822",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Work Out World",
      "poi_type": "Other",
      "poi_address": "56R Depot St, Randolph, MA 02368, USA",
      "poi_short_description": "Work Out World, a Fitness Center in Randolph MA, just 0.4 miles from Woodview At Randolph.",
      "poi_long_description": "Work Out World is the perfect gym for people who want to get in shape and stay in shape. With a wide variety of workout equipment and a friendly staff, Work Out World is a great place to get your workout on.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-6a77-71b1-a2cd-f83035dc4e53.webp",
      "poi_featured_image_media": {
        "alt_text": "WOW! WORK OUT WORLD logo with a globe icon.",
        "public_id": "01a10dc5-6a77-71b1-a2cd-f83035dc4e53",
        "storage_key": "property/6737460151193408/01a10dc5-6a77-71b1-a2cd-f83035dc4e53.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://www.yelp.com/biz/work-out-world-randolph?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=56R%20Depot%20St,%20Randolph,%20MA%2002368,%20USA&travelmode=walking",
      "poi_item_slug": "work-out-world-randolph",
      "poi_latitude": "42.1653425",
      "poi_longitude": "-71.0456824",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_298ca3b4-55bb-41ae-a47e-4077f65baae7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "iLoveKickboxing - Randolph",
      "poi_type": "Other",
      "poi_address": "45 Mazzeo Dr, Randolph, MA 02368, USA",
      "poi_short_description": "iLoveKickboxing - Randolph, a Fitness Center in Randolph MA, just 1.1 miles from Woodview At Randolph.",
      "poi_long_description": "iLoveKickboxing - Randolph is the perfect gym for those who want to get fit and have a great time doing it. Our group fitness classes are high-energy and our instructors are passionate about helping our members reach their fitness goals. Plus, our location near Woodview At Randolph apartments makes it convenient for our members to get to and from our gym.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-6a5d-72f8-a46d-8d1201e492ed.webp",
      "poi_featured_image_media": {
        "alt_text": "People doing squats in a fitness class.",
        "public_id": "01a10dc5-6a5d-72f8-a46d-8d1201e492ed",
        "storage_key": "property/6737460151193408/01a10dc5-6a5d-72f8-a46d-8d1201e492ed.webp",
        "width": 960,
        "height": 787
      },
      "poi_business_url": "https://www.yelp.com/biz/ilovekickboxing-randolph-randolph-3?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=45%20Mazzeo%20Dr,%20Randolph,%20MA%2002368,%20USA&travelmode=walking",
      "poi_item_slug": "ilovekickboxing-randolph-randolph-3",
      "poi_latitude": "42.1644999694809",
      "poi_longitude": "-71.0603476760574",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_725413f3-a335-488c-8dd5-13887a917115",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Other",
      "poi_address": "Located Inside LA Fitness, 3 Hawes Wy, Stoughton, MA 02072, USA",
      "poi_short_description": "LA Fitness, a Fitness Center in Stoughton MA, just 2.3 miles from Woodview At Randolph.",
      "poi_long_description": "LA Fitness is a gym that is located near Woodview At Randolph apartments in Stoughton, MA. It is 3.7 mi away from Woodview At Randolph apartments. LA Fitness has a wide variety of equipment and amenities, making it a great choice for those looking for a comprehensive workout experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-6a5a-73b3-a712-5e0d76b9d77c.webp",
      "poi_featured_image_media": {
        "alt_text": "Woman running on a treadmill in a fitness center",
        "public_id": "01a10dc5-6a5a-73b3-a712-5e0d76b9d77c",
        "storage_key": "property/6737460151193408/01a10dc5-6a5a-73b3-a712-5e0d76b9d77c.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/la-fitness-stoughton?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=Located%20Inside%20LA%20Fitness,%203%20Hawes%20Wy,%20Stoughton,%20MA%2002072,%20USA&travelmode=walking",
      "poi_item_slug": "la-fitness-stoughton",
      "poi_latitude": "42.1521725185753",
      "poi_longitude": "-71.0708027822263",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_1e4b4f0e-1be4-4bfd-a9d0-0c381b85ec5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "CoreBox Training Center",
      "poi_type": "Other",
      "poi_address": "11 Randolph Rd, Randolph, MA 02368, USA",
      "poi_short_description": "CoreBox Training Center, a Fitness Center in Randolph MA, just 2.4 miles from Woodview At Randolph.",
      "poi_long_description": "CoreBox Training Center gym is a state-of-the-art, fully equipped gym that offers a wide range of classes and personal training services. The gym is located near Woodview At Randolph apartments and is just 2.4 miles away, making it the perfect place to get your workout in. The gym features top-of-the-line equipment and facilities, and the staff is passionate about helping you reach your fitness goals. Whether you're looking to lose weight, build muscle, or just get in shape, CoreBox Training Center gym is the perfect place for you.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-6a87-71cb-8790-146505678a3d.webp",
      "poi_featured_image_media": {
        "alt_text": "Before and after photos of a woman; first photo shows her on a street, second photo shows her with a man, both smiling.",
        "public_id": "01a10dc5-6a87-71cb-8790-146505678a3d",
        "storage_key": "property/6737460151193408/01a10dc5-6a87-71cb-8790-146505678a3d.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/corebox-training-center-randolph?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=11%20Randolph%20Rd,%20Randolph,%20MA%2002368,%20USA&travelmode=walking",
      "poi_item_slug": "corebox-training-center-randolph",
      "poi_latitude": "42.1866035461426",
      "poi_longitude": "-71.0274963378906",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_7c9bd4f1-06f7-432e-ad0e-2c591a41406d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "SetPoint RX",
      "poi_type": "Other",
      "poi_address": "438 N Franklin St, Holbrook, MA 02343, USA",
      "poi_short_description": "SetPoint RX, a Fitness Center in Holbrook MA, just 3.3 miles from Woodview At Randolph.",
      "poi_long_description": "SetPoint RX gym is a state-of-the-art fitness facility that offers a wide variety of cardiovascular and strength-training equipment, as well as a variety of group fitness classes. The gym is located near Woodview At Randolph apartments in Holbrook, MA, and is just a short 3.3 mile drive away.",
      "poi_featured_image": "https://s3-media4.fl.yelpcdn.com/bphoto/Tcl4QiEA5K7RaVbB2kshqA/o.jpg",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/setpoint-rx-holbrook-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://www.google.com/maps/dir/?api=1&origin=33%20Highland%20Glen%20Dr%20#106,%20Randolph,%20MA%2002368,%20USA&destination=438%20N%20Franklin%20St,%20Holbrook,%20MA%2002343,%20USA&travelmode=walking",
      "poi_item_slug": "setpoint-rx-holbrook-2",
      "poi_latitude": "42.16772",
      "poi_longitude": "-71.0075",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_237091bd-12ed-4bd5-8dbc-53cd2a877ca3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Hfcn",
      "poi_type": "Other",
      "poi_address": "152 York St, Stoughton, MA 02072, USA",
      "poi_short_description": "Hfcn, is a nearby Hospital/Medical Center in Stoughton MA, just 4.3 miles from Woodview At Randolph.",
      "poi_long_description": "Hfcn Hospitals is a great hospital for those who live in the Stoughton area. It is located near Woodview At Randolph apartments and is only 4.3 miles away. This hospital is known for its excellent care and its ability to provide a wide range of services. Hfcn Hospitals has a strong reputation and is a top choice for many in the area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-883d-77fe-a386-3bebca7d140f.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of New England Sinai Hospital with a tree in the foreground.",
        "public_id": "01a10dc5-883d-77fe-a386-3bebca7d140f",
        "storage_key": "property/6737460151193408/01a10dc5-883d-77fe-a386-3bebca7d140f.webp",
        "width": 300,
        "height": 168
      },
      "poi_business_url": "https://www.yelp.com/biz/hfcn-stoughton?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "hfcn-stoughton",
      "poi_latitude": "42.1455421447754",
      "poi_longitude": "-71.0978546142578",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_b5aa1eee-5d18-4c2b-93cf-1c62789d5221",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Shields Mri",
      "poi_type": "Other",
      "poi_address": "265 Westgate Dr, Brockton, MA 02301, USA",
      "poi_short_description": "Shields Mri, is a nearby Hospital/Medical Center in Brockton MA, just 8.1 miles from Woodview At Randolph.",
      "poi_long_description": "Shields MRI Hospitals is a state-of-the-art facility that offers a wide range of diagnostic and treatment services. We are located near Woodview At Randolph apartments in Brockton, MA, and are just 8.1 miles away. Our hospital is equipped with the latest MRI technology, and our team of experienced specialists provide compassionate care to each and every patient. Whether you need a routine MRI or are facing a complex health issue, we are here to help.",
      "poi_featured_image": "https://s3-media1.fl.yelpcdn.com/bphoto/DTU4M8Y7X8pC5ggCb1mFeA/o.jpg",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/shields-mri-brockton?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "shields-mri-brockton",
      "poi_latitude": "42.097599",
      "poi_longitude": "-71.0492783",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_3e05cf4a-693f-4cb1-9076-46f9cb55bf1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Caritas Good Samaritan Medical Center",
      "poi_type": "Other",
      "poi_address": "235 N Pearl St, Brockton, MA 02301, USA",
      "poi_short_description": "Caritas Good Samaritan Medical Center, is a nearby Hospital/Medical Center in Brockton MA, just 6.9 miles from Woodview At Randolph.",
      "poi_long_description": "Caritas Good Samaritan Medical Center Hospitals are located near Woodview At Randolph apartments In Brockton MA and are 6.9 mi miles away from Woodview At Randolph apartments. They are a nonprofit, Level 1 trauma center, and the only safety net hospital in Brockton. They offer a wide range of services to the community, including primary care, mental health, and substance abuse services. They also have a Level 3 NICU and a Level 2 trauma center.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/caritas-good-samaritan-medical-center-brockton?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "caritas-good-samaritan-medical-center-brockton",
      "poi_latitude": "42.09814",
      "poi_longitude": "-71.06573",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_5a385d8a-679a-47f5-b68c-9016fe06d345",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Curahealth Stoughton",
      "poi_type": "Other",
      "poi_address": "909 Sumner St, Stoughton, MA 02072, USA",
      "poi_short_description": "Curahealth Stoughton, is a nearby Hospital/Medical Center in Stoughton MA, just 6.4 miles from Woodview At Randolph.",
      "poi_long_description": "Curahealth Stoughton Hospitals is a top-rated hospital in Stoughton, MA, that is just 6.4 miles away from Woodview At Randolph apartments. The hospital has a wide range of services and specialists, making it a great choice for those in need of medical care. The staff is known for being friendly and helpful, and they are always available to answer any questions you may have. Whether you need to be seen for a routine check-up or you are dealing with a more serious health issue, Curahealth Stoughton Hospitals is a great choice.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-8848-766d-89bd-df31c53910b7.webp",
      "poi_featured_image_media": {
        "alt_text": "Conference room with projector screen and conference table.",
        "public_id": "01a10dc5-8848-766d-89bd-df31c53910b7",
        "storage_key": "property/6737460151193408/01a10dc5-8848-766d-89bd-df31c53910b7.webp",
        "width": 1000,
        "height": 666
      },
      "poi_business_url": "https://www.yelp.com/biz/curahealth-hospital-stoughton-stoughton?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "curahealth-hospital-stoughton-stoughton",
      "poi_latitude": "42.10042",
      "poi_longitude": "-71.0831199",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_693281c2-1484-4633-b2b1-8b1baaec0559",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Shields Pet Imaging At South Shore Hospital",
      "poi_type": "Other",
      "poi_address": "55 Fogg Rd, Weymouth, MA 02190, USA",
      "poi_short_description": "Shields Pet Imaging At South Shore Hospital, is a nearby Hospital/Medical Center in Weymouth MA, just 6.5 miles from Woodview At Randolph.",
      "poi_long_description": "South Shore Hospital is a full-service, community hospital serving the residents of southeastern Massachusetts. The hospital is located in Weymouth, Massachusetts, just 6.5 miles from the Woodview at Randolph apartments. South Shore Hospital offers a wide range of services, including emergency care, surgery, and maternity care. The hospital is also home to the Shields Pet Imaging Center, which provides a wide range of diagnostic imaging services for pets.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/shields-pet-imaging-at-south-shore-hospital-weymouth?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "shields-pet-imaging-at-south-shore-hospital-weymouth",
      "poi_latitude": "42.175679",
      "poi_longitude": "-70.954162",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_faf180df-ac5d-4eea-80ab-69eda94b3c3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "South Shore Hospital",
      "poi_type": "Other",
      "poi_address": "55 Fogg Rd, Weymouth, MA 02190, USA",
      "poi_short_description": "South Shore Hospital, is a nearby Hospital/Medical Center in South Weymouth MA, just 6.0 miles from Woodview At Randolph.",
      "poi_long_description": "South Shore Hospital is located in South Weymouth, MA, 6.0 miles away from Woodview At Randolph apartments. The hospital provides a full range of medical and surgical services to the residents of the South Shore region. The hospital has a 24-hour emergency department, a birthing center, and a Level II trauma center. South Shore Hospital also offers a wide variety of outpatient services, including cancer care, cardiac rehabilitation, and physical therapy.",
      "poi_featured_image": "https://s3-media4.fl.yelpcdn.com/bphoto/fy2StAstRO3WUpg39P74ag/o.jpg",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/south-shore-hospital-south-weymouth?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "south-shore-hospital-south-weymouth",
      "poi_latitude": "42.175584",
      "poi_longitude": "-70.954214",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_70d1b7e7-acef-48f6-a0b6-253632e1548e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Boston Children's Physicians Weymouth",
      "poi_type": "Other",
      "poi_address": "541 Main St, Weymouth, MA 02190, USA",
      "poi_short_description": "Boston Children's Physicians Weymouth, is a nearby Hospital/Medical Center in Weymouth MA, just 6.9 miles from Woodview At Randolph.",
      "poi_long_description": "Boston Children's Physicians Weymouth Pediatricians is a top-rated pediatrician's office that is located near Woodview At Randolph apartments in Weymouth MA. They are 6.9 miles away from Woodview At Randolph apartments and offer a variety of services for children of all ages. They are dedicated to providing the best possible care for their patients and their families.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/boston-childrens-physicians-weymouth-weymouth?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "boston-childrens-physicians-weymouth-weymouth",
      "poi_latitude": "42.188",
      "poi_longitude": "-70.95591",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_b31f5295-d7a0-46a0-80cd-f828f4cccda3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Milton Hospital",
      "poi_type": "Other",
      "poi_address": "7 Arrowhead Ln, Milton, MA 02186, USA",
      "poi_short_description": "Milton Hospital, is a nearby Hospital/Medical Center in Milton MA, just 10.3 miles from Woodview At Randolph.",
      "poi_long_description": "Milton Hospital is a community hospital in Milton, Massachusetts. The hospital is 10.3 miles away from Woodview at Randolph apartments. The hospital offers a wide range of services, including emergency care, surgery, and rehabilitation. The hospital has a staff of highly trained and experienced doctors who are dedicated to providing the best possible care for their patients.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/milton-hospital-milton?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "milton-hospital-milton",
      "poi_latitude": "42.2390670776367",
      "poi_longitude": "-71.0840606689453",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_328e934f-842c-4857-bc6f-791acf3a561c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Primarycare Affiliates",
      "poi_type": "Other",
      "poi_address": "130 Quincy Ave, Brockton, MA 02302, USA",
      "poi_short_description": "Primarycare Affiliates, is a nearby Hospital/Medical Center in Brockton MA, just 6.8 miles from Woodview At Randolph.",
      "poi_long_description": "Looking for a new Internal Medicine doctor near Woodview At Randolph apartments in Brockton MA? Check out Primarycare Affiliates! They are located just 6.8 miles away and offer a wide range of services to meet your needs. From annual physicals and vaccinations to sick visits and chronic disease management, they have you covered. Plus, their convenient location and flexible hours make them a great choice for busy adults. Schedule an appointment today and see why Primarycare Affiliates is a top choice for Internal Medicine in Brockton MA.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/primarycare-affiliates-brockton?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "primarycare-affiliates-brockton",
      "poi_latitude": "42.08875",
      "poi_longitude": "-70.99263",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    },
    {
      "id": "custom_5e1de28e-aa58-42c3-a1ca-0956060c4a7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "poi_name": "Atrius Womens Center",
      "poi_type": "Other",
      "poi_address": "51 Performance Dr, Weymouth, MA 02189, USA",
      "poi_short_description": "Atrius Womens Center, is a nearby Hospital/Medical Center in Weymouth MA, just 7.7 miles from Woodview At Randolph.",
      "poi_long_description": "The Atrius Women's Center is a state-of-the-art hospital that provides comprehensive care for women of all ages. The hospital is located near Woodview at Randolph apartments in Weymouth, MA, and is just 7.7 miles away. The Women's Center offers a wide range of services, including obstetrics and gynecology, fertility and reproductive medicine, and cancer care. In addition, the hospital has a Level III neonatal intensive care unit and a 24-hour emergency department. The Atrius Women's Center is committed to providing the highest quality of care to its patients, and its staff is dedicated to providing compassionate and attentive care.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/atrius-womens-center-weymouth?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=42.1622123,-71.05018609999999",
      "poi_item_slug": "atrius-womens-center-weymouth",
      "poi_latitude": "42.194519",
      "poi_longitude": "-70.9435501",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ_cWFZFWC5IkRI40iI2e5eB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": ""
    }
  ],
  "office_hours": [
    {
      "id": "custom_33607a06-650a-4c98-b025-d01dd6c9f962",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e492ffbc-cf6f-4f50-8dd4-e502c3c04ada",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c2a30a52-c64c-4059-925b-956ae1ab8ad4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3dc326fe-7ff0-4045-a4dd-a44136cd18f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_274a3a8a-46d8-4d4e-be8a-e17d196ec1aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d1f68d54-934c-4b81-9475-8b9df5488e57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_07eb11b5a24df0185404fec3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "rating": "4",
      "name": "Qua Williams",
      "text": "Aja was the leasing agent who conducted my apartment viewing, and she was absolutely wonderful to work with. She was professional, polite, and consistently available throughout my entire move-in process. She made everything smooth and stress-free, always responding promptly to my questions and providing helpful guidance. I highly recommend Aja to anyone with moving or leasing needs at Woodview at Randolph.",
      "date": "2026-02-16",
      "title": "false"
    },
    {
      "id": "ec_0f80e66d183e23ea8b858c34",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "rating": "5",
      "name": "Brittany Walker",
      "text": "Let’s just say I have lived here in the past and am so excited to relocate back. Aja has been the most helpful with making this transition possible. Very attentive, professional and on top of everything. I have visited property and the new features are awesome. Always greeted with positive energy from Tom and Aja. Thank you guys for everything.",
      "date": "2026-02-10",
      "title": "false"
    },
    {
      "id": "ec_02b1f51cf2885962d99cc0d3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "rating": "5",
      "name": "Gwendolyn Stokes Chance",
      "text": "The Staff are professional.  You are welcome to discuss your experiences with staff about their services they provide.  A great atmosphere to live in because of its unique style and natural environment.",
      "date": "2026-05-20",
      "title": "false"
    },
    {
      "id": "ec_eda17a1a18a14627743de0a0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "rating": "5",
      "name": "Gregory",
      "text": "Wood view great for its location and food Selection, High way option to travel lousy on pet control mice the biggest issue only other than that I give them five stars, but they need to clean up this my situation also, the management office employers do a great job all of them they could do better but they go above and beyond",
      "date": "2026-05-06",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_90de0900-1237-4a84-9d0d-158d386474ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d07a0-820d-73d8-ac84-368d48e5ad62.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Treadmills and exercise bikes in a well-lit community gym with mirrors.",
        "public_id": "019d07a0-820d-73d8-ac84-368d48e5ad62",
        "storage_key": "property/6737460151193408/019d07a0-820d-73d8-ac84-368d48e5ad62.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ibmYaeyBzz5&play=1"
    },
    {
      "id": "custom_95521197-aea6-4b16-95ac-1f677b82f471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/019d079f-de73-701a-942f-157be3f26d4b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Empty closet with shelves",
        "public_id": "019d079f-de73-701a-942f-157be3f26d4b",
        "storage_key": "property/6737460151193408/019d079f-de73-701a-942f-157be3f26d4b.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Storage Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7AzZQj3SU8H&play=1"
    },
    {
      "id": "custom_6bdf2a50-8da0-4906-b675-3f1f6e2ef8e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193408/01a10dc5-ba27-728e-921a-e58abe7d0d12.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a10dc5-ba27-728e-921a-e58abe7d0d12",
        "storage_key": "property/6737460151193408/01a10dc5-ba27-728e-921a-e58abe7d0d12.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 BR, 1 BA - The Maple",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=jsDX7EHoznn&play=1"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_fbb8b8231e8108bff6107d53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "engrain",
      "external_id": "362230",
      "name": "Utility - Electric - Third Party",
      "description": "Amount for provision and consumption of electric paid to a third party.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_95f247bead964ea6c0fd27eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "engrain",
      "external_id": "362231",
      "name": "Security Deposit (starting at)",
      "description": "Amount intended to be held through residency that may be applied toward amounts owed at move-out. Refunds processed per application and lease terms.",
      "amount": 1000,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_93725253e38f9300341d8e3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "engrain",
      "external_id": "362232",
      "name": "Pet Rent - Cat",
      "description": "false",
      "amount": 30,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "cats",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_99cde91c023e3f76ce2cdca1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "engrain",
      "external_id": "362234",
      "name": "Utility - Natural Gas - Third Party",
      "description": "Amount for provision and consumption of natural gas paid to a third party.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_47a1c198e912ceb194af6b02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "engrain",
      "external_id": "362235",
      "name": "Storage",
      "description": "false",
      "amount": 40,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "storage",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2a95676d25e51d8571b264ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "engrain",
      "external_id": "362236",
      "name": "Utility - Water / Sewer",
      "description": "Amount for provision and / or consumption of water and sewer services.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8d2187337b3e2b2c23aa9707",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "engrain",
      "external_id": "362237",
      "name": "Renters Liability Insurance - Third Party",
      "description": "Amount for renters liability insurance obtained through resident's provider of choice.",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Varies",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "insurance",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_451b1a6c78cd98c2ca1f671b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "engrain",
      "external_id": "495886",
      "name": "Pet Rent - Dog",
      "description": "false",
      "amount": 55,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "dogs",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199647c-20d5-70b8-bb9f-fe774d8ddc95",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "dolben-woodview-at-randolph",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-randolph-ma",
      "search_query": "pet friendly apartments in Randolph MA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Randolph MA",
      "h2_subtitle": "Discover pet friendly apartments in Randolph MA. Woodview at Randolph offers spacious layouts and amazing amenities for you and your furry friend.",
      "page_copy": "Looking for pet friendly apartments in Randolph MA? Woodview at Randolph is the perfect destination for you and your furry companion. Nestled in the charming neighborhood of Randolph, this community welcomes pets and provides dedicated amenities like a spacious dog park, perfect for your pet's daily exercise.\n\nBeyond its pet-centric features, Woodview at Randolph delivers a remarkable living experience with stylish one- and two-bedroom floor plans. Elevate your lifestyle with our resort-style amenities including a refreshing pool, a fully equipped fitness center, and convenient disability access. Connect with us today to explore these perks and make a move towards comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
      "featured_image_media": {
        "alt_text": "Dining area with a table set for four, adjacent to a kitchen.",
        "public_id": "019d07a0-aa4a-7717-b3a0-ac28d2b218a0",
        "storage_key": "property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Randolph MA",
      "seo_description": "Find pet friendly apartments at Woodview in Randolph, MA. Enjoy spacious layouts with amenities for you and your furry friend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "generator",
      "page_item_url": "apartments-with-pool-near-outer-quincy",
      "search_query": "apartments with a pool near Outer Quincy",
      "category": "Amenity",
      "h1_title": "Apartments with Pool Near Outer Quincy",
      "h2_subtitle": "Discover apartments with a pool near Outer Quincy. Dive into luxury living at Woodview at Randolph, just a short drive away.",
      "page_copy": "Dreaming of apartments with a pool near Outer Quincy? Woodview at Randolph is the ideal community for those seeking resort-style living just minutes from Outer Quincy. Our in-ground pool, accompanied by a lifeguard, offers a safe and refreshing escape, perfect for both leisure and exercise.\n\nBeyond the pool, Woodview at Randolph provides residents with an outstanding living experience. Choose from modern one- or two-bedroom floor plans, complete with premium amenities like a state-of-the-art fitness center and diverse activity areas. Become part of a vibrant community and explore nearby attractions in the Randolph area today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
      "featured_image_media": {
        "alt_text": "Dining area with a table set for four, adjacent to a kitchen.",
        "public_id": "019d07a0-aa4a-7717-b3a0-ac28d2b218a0",
        "storage_key": "property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool Near Outer Quincy",
      "seo_description": "Explore Woodview in Randolph, offering apartments with a pool near Outer Quincy. Enjoy modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-randolph-02368",
      "search_query": "fitness center apartments Randolph 02368",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Randolph",
      "h2_subtitle": "Experience fitness-focused living in Randolph 02368. Enjoy top-notch in-house fitness amenities at Woodview at Randolph.",
      "page_copy": "Searching for fitness center apartments in Randolph 02368? Woodview at Randolph offers an exceptional lifestyle tailored for fitness enthusiasts. Our state-of-the-art fitness center is equipped with everything you need to maintain an active lifestyle without leaving the comfort of your community.\n\nLocated in the heart of Randolph, Woodview provides a selection of one- and two-bedroom floor plans that perfectly blend style and convenience. In addition to a comprehensive fitness center, residents enjoy a refreshing in-ground pool, a dog park, and accessible amenities like disability access. Elevate your lifestyle and discover the benefits of living at Woodview at Randolph today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
      "featured_image_media": {
        "alt_text": "Dining area with a table set for four, adjacent to a kitchen.",
        "public_id": "019d07a0-aa4a-7717-b3a0-ac28d2b218a0",
        "storage_key": "property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Randolph",
      "seo_description": "Discover Randolph 02368's top fitness center apartments. Enjoy premium perks at Woodview, ideal for fitness lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "generator",
      "page_item_url": "apartments-with-dishwashers-randolph",
      "search_query": "apartments with dishwashers in Randolph",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in Randolph",
      "h2_subtitle": "Enjoy modern convenience with apartments featuring dishwashers in Randolph. Woodview at Randolph offers the perfect blend of comfort and style.",
      "page_copy": "Are you in search of apartments with dishwashers in Randolph? Look no further than Woodview at Randolph, where convenience meets modern living. Our thoughtfully designed one- and two-bedroom apartments come equipped with dishwashers, making daily chores a breeze and giving you more time to relax and enjoy life.\n\nNestled in a prime location, Woodview at Randolph offers more than just conveniences like dishwashers. Take advantage of our resort-style amenities, including an in-ground pool with a lifeguard, a well-equipped fitness center, and a dog park. Experience the comfort and charm of Randolph living at its finest by making Woodview your next home destination.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
      "featured_image_media": {
        "alt_text": "Dining area with a table set for four, adjacent to a kitchen.",
        "public_id": "019d07a0-aa4a-7717-b3a0-ac28d2b218a0",
        "storage_key": "property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwashers in Randolph",
      "seo_description": "Find Randolph apartments with dishwashers at Woodview. Enjoy style and convenience in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-milton",
      "search_query": "air conditioned apartments near Milton",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Milton",
      "h2_subtitle": "Stay cool in air conditioned apartments near Milton. Discover comfort and modern amenities at Woodview at Randolph, your new home.",
      "page_copy": "Searching for air conditioned apartments near Milton? Woodview at Randolph offers the perfect retreat just minutes from Milton, ensuring your home remains cool and comfortable regardless of the season. Each apartment is designed to provide you with the utmost comfort and modern-day conveniences.\n\nChoose from our stylish one- or two-bedroom floor plans and enjoy not only air conditioning but also a host of additional amenities. Relax by our in-ground pool, work out in our fitness center, or mingle with fellow residents at the BBQ picnic area. Discover the ideal blend of style and comfort at Woodview at Randolph, conveniently located near Milton.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
      "featured_image_media": {
        "alt_text": "Dining area with a table set for four, adjacent to a kitchen.",
        "public_id": "019d07a0-aa4a-7717-b3a0-ac28d2b218a0",
        "storage_key": "property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near Milton",
      "seo_description": "Explore air conditioned apartments near Milton at Woodview in Randolph. Enjoy comfort and a wealth of top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-randolph-ma",
      "search_query": "two bedroom apartments randolph ma",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Randolph, MA",
      "h2_subtitle": "Discover spacious two bedroom apartments in Randolph, MA. Woodview at Randolph offers comfort and convenience in a vibrant community.",
      "page_copy": "Are you looking for two bedroom apartments in Randolph, MA? Woodview at Randolph provides a perfect living experience with spacious two-bedroom layouts designed for both comfort and style. Each apartment features modern finishes and thoughtful amenities that enhance day-to-day living.\n\nLocated in the heart of Randolph, Woodview offers more than just a place to call home. Residents enjoy a variety of community features, including a refreshing in-ground pool, a well-equipped fitness center, and a welcoming BBQ picnic area. With its prime location and modern conveniences, Woodview at Randolph stands out as an ideal choice for those seeking two-bedroom apartments in this charming town.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
      "featured_image_media": {
        "alt_text": "Dining area with a table set for four, adjacent to a kitchen.",
        "public_id": "019d07a0-aa4a-7717-b3a0-ac28d2b218a0",
        "storage_key": "property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Randolph, MA",
      "seo_description": "Find spacious two bedroom apartments at Woodview in Randolph, MA. Enjoy prime amenities and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-near-outer-quincy",
      "search_query": "one bedroom apartments near outer quincy",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near Outer Quincy",
      "h2_subtitle": "Explore one bedroom apartments near Outer Quincy. Discover comfort and modern amenities at Woodview at Randolph.",
      "page_copy": "Looking for one bedroom apartments near Outer Quincy? Woodview at Randolph offers beautifully designed one-bedroom apartments that provide both convenience and modern living in a fantastic location. With an emphasis on comfort and style, our residences make it easy to unwind and enjoy your personal space.\n\nSituated just a short drive from Outer Quincy, Woodview at Randolph allows you to experience the best of both worlds: a peaceful home environment with easy access to vibrant city life. Residents benefit from on-site amenities including a fitness center, in-ground pool, and dog park. Discover your next home at Woodview, where modern amenities and a great location meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
      "featured_image_media": {
        "alt_text": "Dining area with a table set for four, adjacent to a kitchen.",
        "public_id": "019d07a0-aa4a-7717-b3a0-ac28d2b218a0",
        "storage_key": "property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near Outer Quincy",
      "seo_description": "Discover one bedroom apartments near Outer Quincy at Woodview in Randolph. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162250",
      "property_id": "6737460151193408",
      "source": "generator",
      "page_item_url": "studio-apartments-in-02368",
      "search_query": "studio apartments in 02368",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in 02368 Area",
      "h2_subtitle": "Find studio apartments in the 02368 area. Discover modern living at Woodview at Randolph, designed for comfort and convenience.",
      "page_copy": "In search of studio apartments in the 02368 area? While Woodview at Randolph primarily offers one and two-bedroom options, our community is perfectly situated in Randolph, providing access to a variety of apartment styles just a short distance away. Experience the benefits of living in a location that combines comfort, style, and convenience.\n\nOur residents enjoy a wealth of amenities including an in-ground pool with a lifeguard, a well-equipped fitness center, and inviting BBQ picnic areas. Though we specialize in larger apartments, our community is an ideal choice for anyone looking to live in the vibrant Randolph area, close to all that the 02368 zip code has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
      "featured_image_media": {
        "alt_text": "Dining area with a table set for four, adjacent to a kitchen.",
        "public_id": "019d07a0-aa4a-7717-b3a0-ac28d2b218a0",
        "storage_key": "property/6737460151193408/019d07a0-aa4a-7717-b3a0-ac28d2b218a0.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in 02368 Area",
      "seo_description": "Explore studio apartments in the 02368 zip at Woodview in Randolph. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "dania@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3520"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028658424"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KGPZSP9J"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://woodviewat2.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_cort_lead_form_id",
      "type": "STRING",
      "value": "Woodview_at_Randolph_JC2HIOcgd5rH0DDrlENg"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "18468314501"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/r5v52mjmvny"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_mri_tour_scheduler_url",
      "type": "STRING",
      "value": "https://dolben.leadmanagement.mrisoftware.com/schedule/schedProcessor.asp?propID=100041&subID=&refID=100497&logo=1"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlBoNisxUHhsU29hcjBtdlNVWmFQMXc9PSIsInZhbHVlIjoiSlAvamVUM3FpNGtZRWwrYW1sZlN0dz09IiwibWFjIjoiMzhmMmM5YWFlMjlmOGVjNjk0Y2E5ZThjOTNiOThhOTQ4ZGM4YzE4ZTVlZWUxNjE4YjdjMDFmYWE1NTIwNzcwNSJ9"
    }
  ],
  "custom_csm": "dania@repli360.com",
  "custom_qb_id": "3520",
  "custom_repli_id": "5028658424",
  "custom_google_gtm_id": "GTM-KGPZSP9J",
  "custom_ads_subscription": "none",
  "custom_betterbot_script": "<script src=\"https://woodviewat2.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_seo_subscription": "essential",
  "custom_cort_lead_form_id": "Woodview_at_Randolph_JC2HIOcgd5rH0DDrlENg",
  "custom_hubspot_company_id": "18468314501",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/r5v52mjmvny",
  "custom_website_subscription": "turnkey",
  "custom_mri_tour_scheduler_url": "https://dolben.leadmanagement.mrisoftware.com/schedule/schedProcessor.asp?propID=100041&subID=&refID=100497&logo=1",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlBoNisxUHhsU29hcjBtdlNVWmFQMXc9PSIsInZhbHVlIjoiSlAvamVUM3FpNGtZRWwrYW1sZlN0dz09IiwibWFjIjoiMzhmMmM5YWFlMjlmOGVjNjk0Y2E5ZThjOTNiOThhOTQ4ZGM4YzE4ZTVlZWUxNjE4YjdjMDFmYWE1NTIwNzcwNSJ9",
  "custom_audioeye_site_id": "94760330-97d1-4500-ac0d-3296c157df78",
  "custom_audioeye_site_hash": "3e2dd721c36392b0258db55e59f9aad3"
};

export const generatedAt = '2026-11-03T15:47:03.725Z';
